// helper yelp functions

// Get star css based on rating
export function getStarsClass(rating: number): string {
    return "stars" + getStarsSuffix(rating);
}

export function getStarsSuffix(rating: number): string {
    if (rating <= 2.6) {
        if (rating <= 0.1) {
            return "0";
        }
        if (rating <= 0.6) {
            return "0_half";
        }
        if (rating <= 1.1) {
            return "1";
        }
        if (rating <= 1.6) {
            return "1_half";
        }
        if (rating <= 2.1) {
            return "2";
        }
        return "2_half";
    }
    if (rating <= 3.1) {
        return "3";
    }
    if (rating <= 3.6) {
        return "3_half";
    }
    if (rating <= 4.1) {
        return "4";
    }
    if (rating <= 4.6) {
        return "4_half";
    }
    return "5";
}